// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Log_logCard__U\\+AYj {
  margin-bottom: 20px;
}
.Log_logCard__U\\+AYj .ant-card-head-title {
  font-weight: bold;
}

.Log_logControls__Vzety {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.Log_logStats__www3w {
  display: flex;
  gap: 8px;
}

.Log_errorText__7JbCc {
  color: #ff4d4f;
}

.Log_warningText__eafgm {
  color: #faad14;
}

.Log_infoText__ZQ\\+hl {
  color: #1890ff;
}

.Log_debugText__mBeVO {
  color: #52c41a;
}`, "",{"version":3,"sources":["webpack://./src/pages/Detail/component/log/Log.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAEI;EACE,iBAAA;AAAN;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,QAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF","sourcesContent":[".logCard {\n  margin-bottom: 20px;\n  \n  :global {\n    .ant-card-head-title {\n      font-weight: bold;\n    }\n  }\n}\n\n.logControls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.logStats {\n  display: flex;\n  gap: 8px;\n}\n\n.errorText {\n  color: #ff4d4f;\n}\n\n.warningText {\n  color: #faad14;\n}\n\n.infoText {\n  color: #1890ff;\n}\n\n.debugText {\n  color: #52c41a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logCard": `Log_logCard__U+AYj`,
	"logControls": `Log_logControls__Vzety`,
	"logStats": `Log_logStats__www3w`,
	"errorText": `Log_errorText__7JbCc`,
	"warningText": `Log_warningText__eafgm`,
	"infoText": `Log_infoText__ZQ+hl`,
	"debugText": `Log_debugText__mBeVO`
};
export default ___CSS_LOADER_EXPORT___;
